module.exports = __webpack_public_path__ + "static/img/323.7a09903.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201206/323.jpg
// module id = SNB2
// module chunks = 0